const ru = {
  avisoLegal: "Ориентировочный черновик на основе данных, внесённых в NuvliPro. Он не заменяет профессиональную консультацию. Проверьте его со своим бухгалтером перед подачей.",
  lockPago: "Выгрузки для бухгалтера — платная функция.",
  imp: { IVA: "НДС", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Общая территория", canarias: "Канарские острова", ceuta_melilla: "Сеута и Мелилья", foral_pv: "Страна Басков", foral_navarra: "Наварра" },
  tipo: { autonomo: "Самозанятый (физическое лицо)", sociedad: "Компания" },
  q: { 1: "1 кв. · янв–мар", 2: "2 кв. · апр–июн", 3: "3 кв. · июл–сен", 4: "4 кв. · окт–дек" },
  periodoT: "{{n}} кв. {{year}}",
  periodoP: "Платёж {{n}} {{year}}",
  sub: "{{imp}} и подоходный налог по кварталам и за год",
  pie: "Суммы рассчитываются автоматически по выставленным счетам и расходам, внесённым за каждый квартал.",
  regimen: {
    proTitulo: "Тариф Pro:",
    proTexto: "автоматический налоговый режим по территории (НДС, IGIC и форальные налоговые органы), форма 420 на Канарах, форма 202 для компаний, форма 111, напоминания о сроках и проверка качества данных.",
    pasarPro: "Перейти на Pro",
    modelo: " (форма {{m}})",
    pagos: "авансовые платежи: форма {{m}}",
    corregido: "Исправлено вручную · изменить",
    detectado: "Определено автоматически · исправить",
    faltan: "Не хватает налоговых данных ({{que}}): пока вы их не заполните, мы считаем территорию общей, а вас — самозанятым.",
    cp: "почтовый индекс", nif: "NIF/CIF", y: " и ",
    foral: "Ваш налоговый адрес находится в регионе {{nombre}}: НДС и авансовые платежи подаются в {{hacienda}} по собственным форальным формам и срокам. Этот черновик служит ориентиром; декларацию готовит ваш бухгалтер.",
    ipsi: "В Сеуте и Мелилье вместо НДС применяется IPSI. NuvliPro пока его не рассчитывает: попросите бухгалтера подготовить декларацию.",
  },
  card: {
    baseVentas: "База продаж", baseGastos: "База расходов", rep: "{{imp}} начисленный", sop: "{{imp}} к вычету",
    irpf: "Удержанный налог (IRPF)", horas: "Отработано часов", bases: "Базы по ставкам {{imp}}", base: "{{imp}} {{pct}}% · база",
    resultado: "Итог {{imp}} ({{estado}})", aIngresar: "к уплате", aCompensar: "к зачёту",
    igicCanarias: "IGIC · объекты на Канарах", ivaFuera: "НДС · объекты вне Канар",
    ipsiRep: "IPSI начисленный", ipsiAviso: "IPSI не рассчитывается: его готовит ваш бухгалтер.",
    isp: "Обратное начисление · отдельно", ispEmitidas: "Выставленные (база, без налога)", ispRecibidas: "Полученные (база)",
    ispCuota: "Самостоятельно начисленный налог (декларируется и вычитается)",
  },
  btn: {
    docGestoria: "Док. бухгалтеру", docAnual: "Док. бухгалтеру (год)", enviar: "Отправить", m: "Ф.{{m}}", modelo: "Форма {{m}}",
    m420Pro: "Форма 420: тариф Pro", excel: "Excel", ver130: "Открыть 130",
  },
  anual: { titulo: "Итоги {{year}} года", ipsi: "IPSI начисленный (не рассчитывается)", resultado: "Годовой итог {{imp}}" },
  doc: { gestoria: "Документ для бухгалтера", modelo: "Форма {{m}}" },
  toast: {
    generado: "{{doc}}: готово", trimestre: " ({{n}} кв.)", anual: " ({{year}} год)", error: "Не удалось сформировать: {{doc}}",
    excelOk: "Отчёт за {{year}} выгружен для бухгалтера (XLSX)", excelError: "Не удалось выгрузить отчёт",
    m130Error: "Не удалось рассчитать форму 130", reduccionError: "Не удалось сохранить вычет",
  },
  m130: {
    titulo: "Форма 130 — подоходный налог", acum: "(нарастающим итогом, {{n}} кв.)", anual: "({{year}} год)",
    desc: "Авансовый платёж нарастающим итогом за год за вычетом удержаний и сумм, уплаченных в прошлых кварталах.",
    ingresos: "Учитываемые доходы (нарастающим итогом)", gastos: "Вычитаемые расходы (нарастающим итогом)", rendimiento: "Чистый доход",
    reduccion: "Вычет {{pct}} % на трудно подтверждаемые расходы", pago: "Авансовый платёж ({{pct}} %)",
    retenciones: "Удержанные суммы", anteriores: "Платежи прошлых кварталов",
    aIngresar: "Итого к уплате", negativo: "Отрицательный итог (к уплате: 0 €)",
    marcar: "Применить вычет {{pct}} % на трудно подтверждаемые расходы (макс. {{max}} в год). Уточните у бухгалтера.",
    cerrar: "Закрыть", pdf: "Скачать PDF",
  },
  m202: {
    titulo: "Форма 202 — авансовые платежи {{year}} (оценка)",
    desc: "Налог на прибыль компаний: {{pct}} % от накопленной прибыли за год. Ваш бухгалтер может использовать другой способ.",
    plazo: "Платёж {{p}} · подаётся с 1 по 20 {{mes}}", mes: { 1: "апреля", 2: "октября", 3: "декабря" },
    tramo: { 3: "янв–мар", 9: "янв–сен", 11: "янв–ноя" }, beneficio: "Накопленная прибыль ({{tramo}})",
    cuota: "{{pct}} % от прибыли", menos: "Удержания и прошлые платежи", estimacion: "Оценка к уплате",
  },
  m111: {
    titulo: "Форма 111 — удержания {{year}}",
    desc: "Удержания из зарплат (вводите вручную) и с оплат специалистам с удержанием (берутся из ваших расходов).",
    nominas: "Удержания из зарплат (вручную)", profesionales: "Специалисты: получателей — {{n}}, база {{base}}",
    total: "Итого к уплате", guardado: "Удержания из зарплат за {{n}} кв. сохранены",
    errorGuardar: "Не удалось сохранить сумму", invalido: "Введите корректную сумму, например 1234,56",
  },
  enviar: {
    titulo: "Отправить {{n}} кв. {{year}} бухгалтеру",
    desc: "Бухгалтер получит письмо с этими PDF во вложении. Если он ответит, письмо придёт вам.",
    email: "E-mail бухгалтера", placeholder: "buhgalter@primer.ru", boton: "Отправить", ok: "{{n}} кв. {{year}} отправлен на {{email}} ({{docs}} PDF)",
    error: "Проверьте e-mail бухгалтера",
  },
  avisos: {
    plazos: "Ближайшие сроки", sinPlazos: "Ближайших сроков нет.",
    forales: "Форальные сроки: формы подаются в ваш форальный налоговый орган, их готовит бухгалтер.",
    modelos: "Формы {{m}}", rango: "{{periodo}}: с {{desde}} по {{hasta}}",
    hoy: "Заканчивается сегодня", unDia: "Остался 1 день", dias: "Осталось дней: {{n}}",
    recordatorio: "Мы напомним уведомлением и письмом за 10 дней до окончания каждого срока.",
    calidad: "Качество данных {{year}}", ok: "Всё в порядке: в ваших счетах за этот год данные не пропущены.",
    revisar: "Проверить", exenta: "Отметить как освобождённый", exentaOk: "Расход отмечен как освобождённый от налога", exentaError: "Не удалось отметить расход",
  },
  calidad: {
    facturas_nif: "Выставленные счета без NIF клиента или с неверным NIF",
    facturas_cp_obra: "Счета по объектам без почтового индекса объекта (добавьте его в карточке объекта)",
    gastos_sin_impuesto: "Полученные счета без выделенного налога (НДС или IGIC равен 0)",
    gastos_nif: "Полученные счета без NIF поставщика или с неверным NIF",
  },
  ajustes: {
    titulo: "Налоговый режим (квартальный отчёт)", det1: "Определено автоматически:", det2: "по вашему почтовому индексу и",
    det3: "по вашему NIF/CIF. Меняйте, только если это неверно.",
    nota: "Это изменение касается только квартального отчёта. Новые счета по-прежнему предлагают налог по вашему почтовому индексу и индексу клиента.",
    territorio: "Налоговая территория", tipo: "Тип налогоплательщика", automatico: "Автоматически ({{x}})",
    autonomo130: "Самозанятый (форма 130)", sociedad202: "Компания (форма 202)",
    bloqueado: "Автоматический режим входит в тариф Pro.", guardado: "Налоговый режим сохранён", error: "Не удалось сохранить",
  },
};

export default ru;
